/* 货币 格式化 */
const digitsRE = /(\d{3})(?=\d)/g

Number.prototype.toFixed = function (d) {
	var s = this + "";
	if (!d) d = 0;
	if (s.indexOf(".") == -1) s += ".";
	s += new Array(d + 1).join("0");
	if (new RegExp("^(-|\\+)?(\\d+(\\.\\d{0," + (d + 1) + "})?)\\d*$").test(s)) {
		var s = "0" + RegExp.$2, pm = RegExp.$1, a = RegExp.$3.length, b = true;
		if (a == d + 2) {
			a = s.match(/\d/g);
			if (parseInt(a[a.length - 1]) > 4) {
				for (var i = a.length - 2; i >= 0; i--) {
					a[i] = parseInt(a[i]) + 1;
					if (a[i] == 10) {
						a[i] = 0;
						b = i != 1;
					} else break;
				}
			}
			s = a.join("").replace(new RegExp("(\\d+)(\\d{" + d + "})\\d$"), "$1.$2");

		} if (b) s = s.substr(1);
		return (pm + s).replace(/\.$/, "");
	} return this + "";
};

export function currency(value, currency, decimals) {
	value = parseFloat(value)
	if (!isFinite(value) || (!value && value !== 0)) return ''
	currency = currency != null ? currency : '￥'
	decimals = decimals != null ? decimals : 2

	var stringified = Math.abs(value).toFixed(decimals)
	var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified
	var i = _int.length % 3
	var head = i > 0 ? (_int.slice(0, i) + (_int.length > 3 ? ',' : '')) : ''
	var _float = decimals ? stringified.slice(-1 - decimals) : ''
	var sign = value < 0 ? '-' : ''
	return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float
}
export function currencys(value, currency, decimals) {
	value = parseFloat(value)
	if (!isFinite(value) || !value) return ''
	currency = currency != null ? currency : ''
	decimals = decimals !== undefined ? decimals : 2
	var stringified = Math.abs(value).toFixed(decimals)
	var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified
	var i = _int.length % 3
	var head = i > 0 ? (_int.slice(0, i) + (_int.length > 3 ? ',' : '')) : ''
	var _float = decimals ? stringified.slice(-1 - decimals) : ''
	var sign = value < 0 ? '-' : ''
	return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float
}


/** 万元一下整数，万元以上单位（四舍五入保留两位小数）*/
export function filterMoeny(data){
	let reg = /[-]/
	if(!data){
		return data
	}else {
		let str = String(data).replace(reg,'')
		if(Number(str)>10000){
			return  (data / 10000).toFixed(2) + '万';
		}else{
			return data
		}
	}
}



// WEBPACK FOOTER //
// ./src/assets/utils/currencyFormat.js